import styled from 'styled-components';

const BodyText = styled.div`
  p {
    margin-bottom: 25px;
  }
  b, strong, h1, h2, h3, h4, h5, h6 {
    font-weight: bold;
  }
  h1 { font-size: 22px; }
  h2 { font-size: 20px; }
  h3 { font-size: 18px; }
  h4 { font-size: 16px; }
  h5 { font-size: 14px; }
  h6 { font-size: 13px; }
`;

export default BodyText;
